import type { BaseType } from 'antd/es/typography/Base';
import styles from './typography.module.css';

export type TypographySize = 'large' | 'medium' | 'small';

export type TypographyType = 'light' | 'primary' | 'title' | BaseType;

export type TypographyWeight = 'base' | 'bold' | 'medium';

export const typographySizeClassName: Record<TypographySize, string | undefined> = {
  large: styles['large-size'],
  medium: styles['medium-size'],
  small: styles['small-size'],
};

export const typographyWeightClassName: Record<TypographyWeight, string | undefined> = {
  base: styles['base-weight'],
  bold: styles['bold-weight'],
  medium: styles['medium-weight'],
};

export const typographyTypeClassName: Record<TypographyType, string | undefined> = {
  danger: undefined,
  light: styles['light-color'],
  primary: styles['primary-color'],
  secondary: undefined,
  success: undefined,
  title: styles['title-color'],
  warning: undefined,
};

export const generateTypographySizeClassName = (size?: TypographySize) =>
  size ? typographySizeClassName[size] : undefined;

export const generateTypographyWeightClassName = (weigth?: TypographyWeight) =>
  weigth ? typographyWeightClassName[weigth] : undefined;

export const generateTypographyColorClassName = (color?: TypographyType) =>
  color ? typographyTypeClassName[color] : undefined;
